// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-code {
  border-radius: 0.125rem;
  border: 0.00625rem solid rgb(223, 212, 201);
  padding: 0.125rem;
  width: 100%;
  height: 100%;
}
.container-code-title {
  font-size: 0.1125rem;
  font-weight: bold;
  background: #fff;
  height: 0.3125rem;
  line-height: 0.3125rem;
  border-bottom: 0.00625rem solid rgb(223, 212, 201);
  box-shadow: 0.0125rem 0.025rem 0.05rem 0.0125rem rgba(12, 12, 13, 0.1019607843);
  padding: 0 0.125rem;
  margin-bottom: 0.125rem;
  border-radius: 0.0625rem;
  display: flex;
  justify-content: space-between;
}
.container-code-title p span {
  font-size: 0.05rem;
  font-weight: normal;
  color: #a7b0b3;
  margin-left: 0.03125rem;
}
.container-code-title-icons {
  display: flex;
  align-items: center;
}
.container-code-title-icons .ant-btn {
  font-size: 0.075rem;
  background: none;
  color: var(--var-prismer-chatbot);
  box-shadow: none;
  gap: 0.025rem;
  padding: 0.03125rem;
  height: auto;
  margin-right: 0.03125rem;
}
.container-code-title-icons .ant-btn .anticon {
  color: var(--var-prismer-chatbot);
}
.container-code-title-icons .ant-btn .anticon:hover {
  transform: none;
}
.container-code-title-icons .anticon {
  color: #f5ce8a;
  font-size: 0.125rem;
  margin: 0 0 0 0.0625rem;
  cursor: pointer;
}
.container-code-title-icons > span {
  display: flex;
  align-items: center;
}
.container-code-title-icons img {
  margin-left: 0.0625rem;
  max-width: 0.125rem;
}
.container-code-title-icons .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover {
  background: rgba(167, 176, 179, 0.7);
  color: #000;
}
.container-code-title-icons .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover .anticon {
  color: #000;
}
.container-code-main {
  width: 100%;
  height: calc(100% - 0.4375rem);
  display: flex;
  justify-content: space-between;
  background: #fdfbf9;
}
.container-code-item {
  border-radius: 0.0625rem;
  border: 0.00625rem solid rgb(223, 212, 201);
  box-shadow: 0.00625rem 0.0125rem 0.025rem 0.0125rem rgba(12, 12, 13, 0.1019607843);
}
.container-code-l {
  width: 22%;
  background: rgb(244, 234, 220);
  padding: 0.0625rem;
}
.container-code-l .code-file-tree {
  width: 100%;
}
.container-code-l .code-file-tree .tree-title-name {
  display: inline-flex;
  width: 60%;
}
.container-code-l .code-file-tree .tree-title-name .title-text {
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.container-code-l-full {
  animation: full 200ms forwards;
}
.container-code-l-full .code-file-tree .tree-title-name {
  display: inline-flex;
  width: 100%;
}
.container-code-l-full .code-file-tree .tree-title-name .title-text {
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@keyframes full {
  0% {
    width: 22%;
  }
  100% {
    width: 100%;
  }
}
.container-code-l h4 {
  font-size: 0.1rem;
  font-weight: bold;
  margin-bottom: 0.0625rem;
  border-bottom: 0.00625rem solid rgb(223, 212, 201);
  line-height: 0.1875rem;
  display: flex;
  align-items: center;
}
.container-code-l h4 img {
  margin-left: 0.03125rem;
  max-width: 0.1rem;
}
.container-code-l-main {
  width: 100%;
  height: calc(100% - 0.1875rem);
  overflow: auto;
}
.container-code-l-main::-webkit-scrollbar {
  width: 0.025rem;
  height: 0.025rem;
  margin-right: 0.0625rem;
}
.container-code-l-main::-webkit-scrollbar-track {
  background-color: var(--var-prismer-color5);
}
.container-code-l-main::-webkit-scrollbar-thumb {
  border-radius: 0.01875rem;
  background-color: #b2b2b2;
}
.container-code-l .file-tree {
  background: none;
}
.container-code-l::-webkit-scrollbar {
  width: 0.025rem;
  height: 0.025rem;
  margin-right: 0.0625rem;
}
.container-code-l::-webkit-scrollbar-track {
  background-color: var(--var-prismer-color5);
}
.container-code-l::-webkit-scrollbar-thumb {
  border-radius: 0.01875rem;
  background-color: #b2b2b2;
}
.container-code-l .file-tree h4 {
  border-bottom: 0.00625rem solid rgb(223, 212, 201);
  margin-bottom: 0.0625rem;
}
.container-code-c {
  width: 33%;
  height: 100%;
  padding: 0.0625rem;
  background: #f9f6f3;
  border-radius: 0.0625rem;
  padding: 10px;
  border: 0.00625rem solid rgb(223, 212, 201);
}
.container-code-c-box {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 0.0625rem;
  border-radius: 0.05rem;
  font-size: 0.0875rem;
}
.container-code-c-box h6 {
  font-size: 0.1rem;
}
.container-code-c-box .des-area-main {
  box-shadow: 0.0125rem 0.025rem 0.05rem 0.0125rem rgba(12, 12, 13, 0.1019607843);
  padding: 0.03125rem;
  border-radius: 0.05rem;
  margin-top: 0.0625rem;
}
.container-code-c-box .des-area-box {
  width: 100%;
  max-height: 1.25rem;
  overflow: auto;
}
.container-code-c-box .des-area-box::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.container-code-c-box .des-area-box pre {
  font-size: 0.0625rem;
  font-weight: 500;
  margin-bottom: 0.0625rem;
  color: #6a6a6c;
  white-space: pre-line;
  margin-top: 0;
  border-radius: 0.05rem;
  border: 0.00625rem solid rgba(12, 12, 12, 0.1);
  background: rgba(12, 12, 12, 0.02);
  padding: 0.03125rem;
  font-family: Roboto;
  line-height: 0.0875rem;
}
.container-code-c-box .des-area-box li {
  list-style: inside;
  font-size: 0.0625rem;
  margin: 0.0125rem 0 0.0125rem 0.0625rem;
  line-height: 0.1rem;
}
.container-code-c-box .des-area-box li .name {
  font-weight: bold;
}
.container-code-c-box .des-area-box li .value {
  color: #97979b;
}
.container-code-c-box .des-area-box ul {
  padding: 0.03125rem;
}
.container-code-c-box .des-area-box .ant-collapse {
  border: none;
  background-color: transparent;
}
.container-code-c-box .des-area-box .ant-collapse-item {
  border-radius: 0.05rem;
}
.container-code-c-box .des-area-box .ant-collapse-item:last-child {
  border-bottom: 0.00625rem solid rgb(251, 229, 240);
}
.container-code-c-box .des-area-box .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  font-size: 0.0375rem;
}
.container-code-c-box .des-area-box .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-expand-icon {
  height: 0.1rem;
  padding-inline-end: 0.03125rem;
}
.container-code-c-box .des-area-box .ant-collapse-content-box {
  padding: 0;
}
.container-code-c-box .des-area-box .ant-collapse-content {
  border-top: none;
  background-color: transparent;
}
.container-code-c-box .des-area-box .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding: 0.03125rem;
  line-height: normal;
  font-size: 0.0625rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  border-radius: 0.05rem;
}
.container-code-c-box .des-area-p {
  border-radius: 0.05rem;
  background: rgba(206, 220, 238, 0.1);
  border: 0.00625rem solid rgba(206, 220, 238, 0.6);
}
.container-code-c-box .des-area-p .ant-collapse-header {
  background: rgba(163, 188, 219, 0.1);
}
.container-code-c-box .des-area-p .name {
  color: rgb(120, 161, 211);
}
.container-code-c-box .des-area-r {
  margin-top: 0.0625rem;
  border-radius: 0.05rem;
  background: rgba(251, 229, 240, 0.1);
  border: 0.00625rem solid rgb(251, 229, 240);
}
.container-code-c-box .des-area-r .ant-collapse-header {
  background: rgba(251, 229, 240, 0.4);
}
.container-code-c-box .des-area-r .name {
  color: rgb(239, 174, 207);
}
.container-code-c-box .change-des-area-box {
  width: 100%;
  max-height: 1.5625rem;
  overflow: auto;
  padding: 0.0125rem 0.025rem 0.0625rem 0.025rem;
  background: rgba(152, 182, 177, 0.1);
  border-radius: 0.05rem;
  margin-top: 0.0625rem;
  color: var(--var-prismer-chatbot);
}
.container-code-c-box .change-des-area-box::-webkit-scrollbar {
  width: 0.025rem;
  height: 0.025rem;
  margin-right: 0.0625rem;
}
.container-code-c-box .change-des-area-box::-webkit-scrollbar-track {
  background-color: var(--var-prismer-color5);
}
.container-code-c-box .change-des-area-box::-webkit-scrollbar-thumb {
  border-radius: 0.01875rem;
  background-color: #b2b2b2;
}
.container-code-c-box .change-des-area-box textarea.ant-input::-webkit-resizer {
  display: none;
}
.container-code-c p {
  font-size: 0.0875rem;
}
.container-code-c h5 {
  font-weight: bold;
  font-size: 0.1rem;
  line-height: 0.1875rem;
}
.container-code-c h6 {
  font-size: 0.075rem;
  line-height: 0.1875rem;
}
.container-code-c .method-name {
  padding: 0.03125rem;
  width: 100%;
  line-height: 0.1875rem;
  background: #f4ede6;
  border-radius: 0.0375rem;
  font-size: 0.0875rem;
}
.container-code-c .change-des-area {
  width: 100%;
  min-height: 0.625rem;
  height: 95%;
  background-color: rgba(152, 182, 177, 0.1);
  border: 0.00625rem solid rgba(152, 182, 177, 0.4);
  font-size: 0.0875rem;
  color: var(--var-prismer-chatbot);
}
.container-code-c .change-des-area::-webkit-scrollbar {
  width: 0.025rem;
  height: 0.025rem;
}
.container-code-c .change-des-area::-webkit-scrollbar-track {
  background-color: var(--var-prismer-color5);
}
.container-code-c .change-des-area::-webkit-scrollbar-thumb {
  border-radius: 0.01875rem;
  background-color: #b2b2b2;
}
.container-code-c .ant-input-outlined:focus,
.container-code-c .ant-input-outlined:hover {
  border: 0.00625rem solid var(--var-prismer-chatbot);
  box-shadow: 0.00625rem 0.0125rem 0.0375rem 0.00625rem rgba(152, 182, 177, 0.2);
}
.container-code-c .apply-suggest {
  height: auto;
  background: var(--var-prismer-chatbot);
  border-radius: 0.025rem;
  margin-top: 0.03125rem;
  font-size: 0.0875rem;
  padding: 0.0125rem 0.0625rem;
  box-shadow: none;
  font-weight: bold;
}
.container-code-c .apply-suggest-disable {
  background: rgba(139, 133, 137, 0.6);
  cursor: not-allowed;
}
.container-code-c .apply-suggest-disable:hover {
  background: rgba(139, 133, 137, 0.6) !important;
  cursor: not-allowed;
}
.container-code-c .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover {
  background: var(--var-prismer-chatbot);
  color: #fff;
}
.container-code-r {
  width: 42%;
  height: 100%;
  padding: 0.0625rem;
  overflow: auto;
}
.container-code-r::-webkit-scrollbar {
  width: 0.025rem;
  height: 0.025rem;
}
.container-code-r::-webkit-scrollbar-track {
  background-color: var(--var-prismer-color5);
}
.container-code-r::-webkit-scrollbar-thumb {
  border-radius: 0.01875rem;
  background-color: #b2b2b2;
}
.container-code-r-full {
  animation: rFull 200ms forwards;
}
.container-code-r-full .tree-title-name {
  width: 100% !important;
}
.container-code-r-full .tree-title-name .title-text {
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: initial !important;
  text-overflow: initial !important;
}
@keyframes rFull {
  0% {
    width: 42%;
  }
  100% {
    width: 76%;
  }
}
.container-code-r-des {
  font-size: 0.0875rem;
  line-height: 0.1875rem;
}
.container-code-r-des-main {
  box-shadow: 0.0125rem 0.025rem 0.05rem 0.0125rem rgba(12, 12, 13, 0.1019607843);
  padding: 0.0625rem;
  border-radius: 0.05rem;
}
.container-code-r-des-main .markdown {
  color: #6a6a6c;
  font-size: 0.075rem;
  font-weight: 500;
  border-radius: 0.05rem;
  box-shadow: 0 0.0125rem 0.025rem rgba(12, 12, 13, 0.1019607843);
  border: 0.00625rem solid rgba(12, 12, 12, 0.1);
  background: rgba(12, 12, 12, 0.02);
  padding: 0.03125rem;
  line-height: 0.0875rem;
  font-family: Roboto;
}
.container-code-r-des h5 {
  font-size: 0.0875rem !important;
  line-height: 0.15625rem !important;
}
.container-code-r h5 {
  font-weight: bold;
  font-size: 0.1rem;
  line-height: 0.1875rem;
}
.container-code-r .code-main {
  width: 100%;
  min-height: 1.25rem;
  height: calc(100% - 0.3125rem);
  background: #1e1e1e;
  border-radius: 0.0625rem;
  margin-top: 0.0625rem;
  font-size: 0.075rem;
}
.container-code-r .code-main-top {
  color: #9ca3af;
  display: flex;
  justify-content: space-between;
  padding: 0.0625rem;
}
.container-code-r .code-main-top .anticon {
  cursor: pointer;
}
.container-code-r .code-main-box {
  min-height: 1rem;
  height: calc(100% - 0.25rem);
  overflow: auto;
}
.container-code-r .code-main-box::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.container-code .ant-drawer {
  position: absolute;
  right: 0;
  top: 0;
}
.container-code .ant-drawer-header {
  padding: 0.1rem 0.125rem;
}
.container-code .ant-drawer-title {
  font-size: 0.1rem;
  font-weight: bold;
}
.container-code .ant-drawer-body {
  font-size: 0.1rem;
  background: rgba(249, 249, 249, 0.1);
  padding: 0.125rem;
}
.container-code .ant-drawer-body::-webkit-scrollbar {
  width: 0.025rem;
  height: 0.025rem;
  margin-right: 0.0625rem;
}
.container-code .ant-drawer-body::-webkit-scrollbar-track {
  background-color: var(--var-prismer-color5);
}
.container-code .ant-drawer-body::-webkit-scrollbar-thumb {
  border-radius: 0.01875rem;
  background-color: #b2b2b2;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/component/containerCode/index.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,2CAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AACF;AAAE;EACE,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kDAAA;EACA,+EAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,aAAA;EACA,8BAAA;AAEJ;AADI;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;AAGN;AADI;EACE,aAAA;EACA,mBAAA;AAGN;AAFM;EACE,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;AAIR;AAHQ;EACE,iCAAA;AAKV;AAJU;EACE,eAAA;AAMZ;AAFM;EACE,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAIR;AAFM;EACE,aAAA;EACA,mBAAA;AAIR;AAFM;EACE,sBAAA;EACA,mBAAA;AAIR;AAFM;EACE,oCAAA;EACA,WAAA;AAIR;AAHQ;EACE,WAAA;AAKV;AAAE;EACE,WAAA;EACA,8BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAEJ;AAAE;EACE,wBAAA;EACA,2CAAA;EACA,kFAAA;AAEJ;AAAE;EACE,UAAA;EACA,8BAAA;EACA,kBAAA;AAEJ;AADI;EACE,WAAA;AAGN;AAFM;EACE,oBAAA;EACA,UAAA;AAIR;AAHQ;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAKV;AADI;EACE,8BAAA;AAGN;AADQ;EACE,oBAAA;EACA,WAAA;AAGV;AAFU;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAIZ;AACI;EACE;IACE,UAAA;EACN;EACI;IACE,WAAA;EACN;AACF;AACI;EACE,iBAAA;EACA,iBAAA;EACA,wBAAA;EACA,kDAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AACN;AAAM;EACE,uBAAA;EACA,iBAAA;AAER;AACI;EACE,WAAA;EACA,8BAAA;EACA,cAAA;AACN;AAAM;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AAER;AAAM;EACE,2CAAA;AAER;AAAM;EACE,yBAAA;EACA,yBAAA;AAER;AACI;EACE,gBAAA;AACN;AACI;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AACN;AACI;EACE,2CAAA;AACN;AACI;EACE,yBAAA;EACA,yBAAA;AACN;AACI;EACE,kDAAA;EACA,wBAAA;AACN;AAEE;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,2CAAA;AAAJ;AACI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;AACN;AAAM;EACE,iBAAA;AAER;AAAM;EACE,+EAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;AAER;AAAM;EACE,WAAA;EACA,mBAAA;EACA,cAAA;AAER;AADQ;EACE,QAAA;EACA,SAAA;AAGV;AADQ;EACE,oBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,8CAAA;EACA,kCAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AAGV;AADQ;EACE,kBAAA;EACA,oBAAA;EACA,uCAAA;EACA,mBAAA;AAGV;AAFU;EACE,iBAAA;AAIZ;AAFU;EACE,cAAA;AAIZ;AADQ;EACE,mBAAA;AAGV;AADQ;EACE,YAAA;EACA,6BAAA;AAGV;AADQ;EACE,sBAAA;AAGV;AAFU;EACE,kDAAA;AAIZ;AADQ;EAIE,oBAAA;AAAV;AAEQ;EAIE,cAAA;EACA,8BAAA;AAHV;AAKQ;EACE,UAAA;AAHV;AAKQ;EACE,gBAAA;EACA,6BAAA;AAHV;AAKQ;EACE,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAHV;AAMM;EACE,sBAAA;EACA,oCAAA;EACA,iDAAA;AAJR;AAKQ;EACE,oCAAA;AAHV;AAKQ;EACE,yBAAA;AAHV;AAMM;EACE,qBAAA;EACA,sBAAA;EACA,oCAAA;EACA,2CAAA;AAJR;AAKQ;EACE,oCAAA;AAHV;AAKQ;EACE,yBAAA;AAHV;AAMM;EACE,WAAA;EACA,qBAAA;EACA,cAAA;EACA,8CAAA;EACA,oCAAA;EACA,sBAAA;EACA,qBAAA;EACA,iCAAA;AAJR;AAKQ;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AAHV;AAKQ;EACE,2CAAA;AAHV;AAKQ;EACE,yBAAA;EACA,yBAAA;AAHV;AAMU;EACE,aAAA;AAJZ;AASI;EACE,oBAAA;AAPN;AASI;EACE,iBAAA;EACA,iBAAA;EACA,sBAAA;AAPN;AASI;EACE,mBAAA;EACA,sBAAA;AAPN;AASI;EACE,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,oBAAA;AAPN;AASI;EACE,WAAA;EACA,oBAAA;EACA,WAAA;EACA,0CAAA;EACA,iDAAA;EACA,oBAAA;EACA,iCAAA;AAPN;AAQM;EACE,eAAA;EACA,gBAAA;AANR;AAQM;EACE,2CAAA;AANR;AAQM;EACE,yBAAA;EACA,yBAAA;AANR;AASI;;EAEE,mDAAA;EACA,8EAAA;AAPN;AASI;EACE,YAAA;EACA,sCAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;AAPN;AAQM;EACE,oCAAA;EACA,mBAAA;AANR;AAOQ;EACE,+CAAA;EACA,mBAAA;AALV;AASI;EACE,sCAAA;EACA,WAAA;AAPN;AAUE;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AARJ;AASI;EACE,eAAA;EACA,gBAAA;AAPN;AASI;EACE,2CAAA;AAPN;AASI;EACE,yBAAA;EACA,yBAAA;AAPN;AASI;EACE,+BAAA;AAPN;AAQM;EACE,sBAAA;AANR;AAOQ;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,4BAAA;EACA,iCAAA;AALV;AASI;EACE;IACE,UAAA;EAPN;EASI;IACE,UAAA;EAPN;AACF;AASI;EACE,oBAAA;EACA,sBAAA;AAPN;AAQM;EACE,+EAAA;EACA,kBAAA;EACA,sBAAA;AANR;AAOQ;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,+DAAA;EACA,8CAAA;EACA,kCAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;AALV;AAQM;EACE,+BAAA;EACA,kCAAA;AANR;AASI;EACE,iBAAA;EACA,iBAAA;EACA,sBAAA;AAPN;AASI;EACE,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,mBAAA;AAPN;AAQM;EACE,cAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;AANR;AAOQ;EACE,eAAA;AALV;AAQM;EACE,gBAAA;EACA,4BAAA;EACA,cAAA;AANR;AAOQ;EACE,QAAA;EACA,SAAA;AALV;AAUE;EACE,kBAAA;EACA,QAAA;EACA,MAAA;AARJ;AASI;EACE,wBAAA;AAPN;AASI;EACE,iBAAA;EACA,iBAAA;AAPN;AASI;EACE,iBAAA;EACA,oCAAA;EACA,iBAAA;AAPN;AAQM;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AANR;AAQM;EACE,2CAAA;AANR;AAQM;EACE,yBAAA;EACA,yBAAA;AANR","sourcesContent":[".container-code {\n  border-radius: 20px;\n  border: 1px solid rgb(223, 212, 201);\n  padding: 20px;\n  width: 100%;\n  height: 100%;\n  &-title {\n    font-size: 18px;\n    font-weight: bold;\n    background: #fff;\n    height: 50px;\n    line-height: 50px;\n    border-bottom: 1px solid rgb(223, 212, 201);\n    box-shadow: 2px 4px 8px 2px #0c0c0d1a;\n    padding: 0 20px;\n    margin-bottom: 20px;\n    border-radius: 10px;\n    display: flex;\n    justify-content: space-between;\n    p span {\n      font-size: 8px;\n      font-weight: normal;\n      color: #a7b0b3;\n      margin-left: 5px;\n    }\n    &-icons {\n      display: flex;\n      align-items: center;\n      .ant-btn {\n        font-size: 12px;\n        background: none;\n        color: var(--var-prismer-chatbot);\n        box-shadow: none;\n        gap: 4px;\n        padding: 5px;\n        height: auto;\n        margin-right: 5px;\n        .anticon {\n          color: var(--var-prismer-chatbot);\n          &:hover {\n            transform: none;\n          }\n        }\n      }\n      .anticon {\n        color: #f5ce8a;\n        font-size: 20px;\n        margin: 0 0 0 10px;\n        cursor: pointer;\n      }\n      > span {\n        display: flex;\n        align-items: center;\n      }\n      img {\n        margin-left: 10px;\n        max-width: 20px;\n      }\n      .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover {\n        background: rgba(167, 176, 179, 0.7);\n        color: #000;\n        .anticon {\n          color: #000;\n        }\n      }\n    }\n  }\n  &-main {\n    width: 100%;\n    height: calc(100% - 70px);\n    display: flex;\n    justify-content: space-between;\n    background: #fdfbf9;\n  }\n  &-item {\n    border-radius: 10px;\n    border: 1px solid rgb(223, 212, 201);\n    box-shadow: 1px 2px 4px 2px #0c0c0d1a;\n  }\n  &-l {\n    width: 22%;\n    background: rgb(244, 234, 220);\n    padding: 10px;\n    .code-file-tree {\n      width: 100%;\n      .tree-title-name {\n        display: inline-flex;\n        width: 60%;\n        .title-text {\n          display: block;\n          width: 100%;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n    }\n    &-full {\n      animation: full 200ms forwards;\n      .code-file-tree {\n        .tree-title-name {\n          display: inline-flex;\n          width: 100%;\n          .title-text {\n            display: block;\n            width: 100%;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n        }\n      }\n    }\n    @keyframes full {\n      0% {\n        width: 22%;\n      }\n      100% {\n        width: 100%;\n      }\n    }\n    h4 {\n      font-size: 16px;\n      font-weight: bold;\n      margin-bottom: 10px;\n      border-bottom: 1px solid rgb(223, 212, 201);\n      line-height: 30px;\n      display: flex;\n      align-items: center;\n      img {\n        margin-left: 5px;\n        max-width: 16px;\n      }\n    }\n    &-main {\n      width: 100%;\n      height: calc(100% - 30px);\n      overflow: auto;\n      &::-webkit-scrollbar {\n        width: 4px;\n        height: 4px;\n        margin-right: 10px;\n      }\n      &::-webkit-scrollbar-track {\n        background-color: var(--var-prismer-color5);\n      }\n      &::-webkit-scrollbar-thumb {\n        border-radius: 3px;\n        background-color: #b2b2b2;\n      }\n    }\n    .file-tree {\n      background: none;\n    }\n    &::-webkit-scrollbar {\n      width: 4px;\n      height: 4px;\n      margin-right: 10px;\n    }\n    &::-webkit-scrollbar-track {\n      background-color: var(--var-prismer-color5);\n    }\n    &::-webkit-scrollbar-thumb {\n      border-radius: 3px;\n      background-color: #b2b2b2;\n    }\n    .file-tree h4 {\n      border-bottom: 1px solid rgb(223, 212, 201);\n      margin-bottom: 10px;\n    }\n  }\n  &-c {\n    width: 33%;\n    height: 100%;\n    padding: 10px;\n    background: #f9f6f3;\n    border-radius: 10px;\n    padding: 10px;\n    border: 1px solid rgb(223, 212, 201);\n    &-box {\n      width: 100%;\n      height: 100%;\n      background: #fff;\n      padding: 10px;\n      border-radius: 8px;\n      font-size: 14px;\n      h6 {\n        font-size: 16px;\n      }\n      .des-area-main {\n        box-shadow: 2px 4px 8px 2px #0c0c0d1a;\n        padding: 5px;\n        border-radius: 8px;\n        margin-top: 10px;\n      }\n      .des-area-box {\n        width: 100%;\n        max-height: 200px;\n        overflow: auto;\n        &::-webkit-scrollbar {\n          width: 0;\n          height: 0;\n        }\n        pre {\n          font-size: 10px;\n          font-weight: 500;\n          margin-bottom: 10px;\n          color: #6a6a6c;\n          white-space: pre-line;\n          margin-top: 0;\n          border-radius: 8px;\n          border: 1px solid rgba(12, 12, 12, 0.1);\n          background: rgba(12, 12, 12, 0.02);\n          padding: 5px;\n          font-family: Roboto;\n          line-height: 14px;\n        }\n        li {\n          list-style: inside;\n          font-size: 10px;\n          margin: 2px 0 2px 10px;\n          line-height: 16px;\n          .name {\n            font-weight: bold;\n          }\n          .value {\n            color: #97979b;\n          }\n        }\n        ul {\n          padding: 5px;\n        }\n        .ant-collapse {\n          border: none;\n          background-color: transparent;\n        }\n        .ant-collapse-item {\n          border-radius: 8px;\n          &:last-child {\n            border-bottom: 1px solid rgb(251, 229, 240);\n          }\n        }\n        .ant-collapse\n          > .ant-collapse-item\n          > .ant-collapse-header\n          .ant-collapse-arrow {\n          font-size: 6px;\n        }\n        .ant-collapse\n          > .ant-collapse-item\n          > .ant-collapse-header\n          .ant-collapse-expand-icon {\n          height: 16px;\n          padding-inline-end: 5px;\n        }\n        .ant-collapse-content-box {\n          padding: 0px;\n        }\n        .ant-collapse-content {\n          border-top: none;\n          background-color: transparent;\n        }\n        .ant-collapse > .ant-collapse-item > .ant-collapse-header {\n          padding: 5px;\n          line-height: normal;\n          font-size: 10px;\n          font-weight: bold;\n          display: flex;\n          align-items: center;\n          border-radius: 8px;\n        }\n      }\n      .des-area-p {\n        border-radius: 8px;\n        background: rgba(206, 220, 238, 0.1);\n        border: 1px solid rgba(206, 220, 238, 0.6);\n        .ant-collapse-header {\n          background: rgba(163, 188, 219, 0.1);\n        }\n        .name {\n          color: rgb(120, 161, 211);\n        }\n      }\n      .des-area-r {\n        margin-top: 10px;\n        border-radius: 8px;\n        background: rgba(251, 229, 240, 0.1);\n        border: 1px solid rgb(251, 229, 240);\n        .ant-collapse-header {\n          background: rgba(251, 229, 240, 0.4);\n        }\n        .name {\n          color: rgb(239, 174, 207);\n        }\n      }\n      .change-des-area-box {\n        width: 100%;\n        max-height: 250px;\n        overflow: auto;\n        padding: 2px 4px 10px 4px;\n        background: rgba(152, 182, 177, 0.1);\n        border-radius: 8px;\n        margin-top: 10px;\n        color: var(--var-prismer-chatbot);\n        &::-webkit-scrollbar {\n          width: 4px;\n          height: 4px;\n          margin-right: 10px;\n        }\n        &::-webkit-scrollbar-track {\n          background-color: var(--var-prismer-color5);\n        }\n        &::-webkit-scrollbar-thumb {\n          border-radius: 3px;\n          background-color: #b2b2b2;\n        }\n        textarea.ant-input {\n          &::-webkit-resizer {\n            display: none;\n          }\n        }\n      }\n    }\n    p {\n      font-size: 14px;\n    }\n    h5 {\n      font-weight: bold;\n      font-size: 16px;\n      line-height: 30px;\n    }\n    h6 {\n      font-size: 12px;\n      line-height: 30px;\n    }\n    .method-name {\n      padding: 5px;\n      width: 100%;\n      line-height: 30px;\n      background: #f4ede6;\n      border-radius: 6px;\n      font-size: 14px;\n    }\n    .change-des-area {\n      width: 100%;\n      min-height: 100px;\n      height: 95%;\n      background-color: rgba(152, 182, 177, 0.1);\n      border: 1px solid rgba(152, 182, 177, 0.4);\n      font-size: 14px;\n      color: var(--var-prismer-chatbot);\n      &::-webkit-scrollbar {\n        width: 4px;\n        height: 4px;\n      }\n      &::-webkit-scrollbar-track {\n        background-color: var(--var-prismer-color5);\n      }\n      &::-webkit-scrollbar-thumb {\n        border-radius: 3px;\n        background-color: #b2b2b2;\n      }\n    }\n    .ant-input-outlined:focus,\n    .ant-input-outlined:hover {\n      border: 1px solid var(--var-prismer-chatbot);\n      box-shadow: 1px 2px 6px 1px rgba(152, 182, 177, 0.2);\n    }\n    .apply-suggest {\n      height: auto;\n      background: var(--var-prismer-chatbot);\n      border-radius: 4px;\n      margin-top: 5px;\n      font-size: 14px;\n      padding: 2px 10px;\n      box-shadow: none;\n      font-weight: bold;\n      &-disable {\n        background: rgba(139, 133, 137, 0.6);\n        cursor: not-allowed;\n        &:hover {\n          background: rgba(139, 133, 137, 0.6) !important;\n          cursor: not-allowed;\n        }\n      }\n    }\n    .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover {\n      background: var(--var-prismer-chatbot);\n      color: #fff;\n    }\n  }\n  &-r {\n    width: 42%;\n    height: 100%;\n    padding: 10px;\n    overflow: auto;\n    &::-webkit-scrollbar {\n      width: 4px;\n      height: 4px;\n    }\n    &::-webkit-scrollbar-track {\n      background-color: var(--var-prismer-color5);\n    }\n    &::-webkit-scrollbar-thumb {\n      border-radius: 3px;\n      background-color: #b2b2b2;\n    }\n    &-full {\n      animation: rFull 200ms forwards;\n      .tree-title-name {\n        width: 100% !important;\n        .title-text {\n          display: block;\n          width: 100%;\n          white-space: nowrap;\n          overflow: initial !important;\n          text-overflow: initial !important;\n        }\n      }\n    }\n    @keyframes rFull {\n      0% {\n        width: 42%;\n      }\n      100% {\n        width: 76%;\n      }\n    }\n    &-des {\n      font-size: 14px;\n      line-height: 30px;\n      &-main {\n        box-shadow: 2px 4px 8px 2px #0c0c0d1a;\n        padding: 10px;\n        border-radius: 8px;\n        .markdown {\n          color: #6a6a6c;\n          font-size: 12px;\n          font-weight: 500;\n          border-radius: 8px;\n          box-shadow: 0 2px 4px #0c0c0d1a;\n          border: 1px solid rgba(12, 12, 12, 0.1);\n          background: rgba(12, 12, 12, 0.02);\n          padding: 5px;\n          line-height: 14px;\n          font-family: Roboto;\n        }\n      }\n      h5 {\n        font-size: 14px !important;\n        line-height: 25px !important;\n      }\n    }\n    h5 {\n      font-weight: bold;\n      font-size: 16px;\n      line-height: 30px;\n    }\n    .code-main {\n      width: 100%;\n      min-height: 200px;\n      height: calc(100% - 50px);\n      background: #1e1e1e;\n      border-radius: 10px;\n      margin-top: 10px;\n      font-size: 12px;\n      &-top {\n        color: #9ca3af;\n        display: flex;\n        justify-content: space-between;\n        padding: 10px;\n        .anticon {\n          cursor: pointer;\n        }\n      }\n      &-box {\n        min-height: 160px;\n        height: calc(100% - 40px);\n        overflow: auto;\n        &::-webkit-scrollbar {\n          width: 0;\n          height: 0;\n        }\n      }\n    }\n  }\n  .ant-drawer {\n    position: absolute;\n    right: 0;\n    top: 0;\n    &-header {\n      padding: 16px 20px;\n    }\n    &-title {\n      font-size: 16px;\n      font-weight: bold;\n    }\n    &-body {\n      font-size: 16px;\n      background: rgba(249, 249, 249, 0.1);\n      padding: 20px;\n      &::-webkit-scrollbar {\n        width: 4px;\n        height: 4px;\n        margin-right: 10px;\n      }\n      &::-webkit-scrollbar-track {\n        background-color: var(--var-prismer-color5);\n      }\n      &::-webkit-scrollbar-thumb {\n        border-radius: 3px;\n        background-color: #b2b2b2;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
